var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "queryForm",
                      attrs: {
                        "label-width": "180px",
                        inline: "",
                        size: "small",
                        model: _vm.dataForm,
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.getDataList()
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                filterable: "",
                                placeholder: "请选择租户",
                              },
                              on: { change: _vm.change },
                              model: {
                                value: _vm.tenantId,
                                callback: function ($$v) {
                                  _vm.tenantId = $$v
                                },
                                expression: "tenantId",
                              },
                            },
                            _vm._l(_vm.listData, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "0=订阅消息,1=微信模板消息",
                            prop: "type",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入0=订阅消息,1=微信模板消息",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dataForm.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "type", $$v)
                              },
                              expression: "dataForm.type",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "模板名", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入模板名",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dataForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "name", $$v)
                              },
                              expression: "dataForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "回复内容", prop: "content" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入回复内容",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dataForm.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "content", $$v)
                              },
                              expression: "dataForm.content",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "模板ID", prop: "freightTemplateId" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入模板ID",
                              clearable: "",
                            },
                            model: {
                              value: _vm.dataForm.freightTemplateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "freightTemplateId", $$v)
                              },
                              expression: "dataForm.freightTemplateId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入状态", clearable: "" },
                            model: {
                              value: _vm.dataForm.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataForm, "status", $$v)
                              },
                              expression: "dataForm.status",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.search },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetQuery },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedTenant && _vm.tenantId
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:templatemessage:save"],
                          expression: "['admin:templatemessage:save']",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.sync()
                        },
                      },
                    },
                    [_vm._v("同步\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedTenant && _vm.tenantId
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.dataListLoading,
                      expression: "dataListLoading",
                    },
                  ],
                  staticClass: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.dataList,
                    size: "mini",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                  on: {
                    "selection-change": _vm.selectionChangeHandle,
                    "sort-change": _vm.handleSortChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "50" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "type",
                      label: "0=订阅消息,1=微信模板消息",
                      "min-width": "180",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.type) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2421275173
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "模板名",
                      "min-width": "180",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.name) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2598451226
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "content",
                      label: "关键词",
                      "min-width": "180",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.content) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1003902004
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "freightTemplateId",
                      label: "模板ID",
                      "min-width": "180",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.freightTemplateId) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2805183171
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mark",
                      label: "模板标识",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.getMarkText(scope.row.mark)) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3433153911
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "模板状态", width: "120", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status === 1
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "success" },
                                    },
                                    [_vm._v("有效")]
                                  )
                                : scope.row.status === 0
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                    },
                                    [_vm._v("无效")]
                                  )
                                : _c(
                                    "el-tag",
                                    {
                                      attrs: { size: "small", type: "warning" },
                                    },
                                    [_vm._v("未配置")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2506620442
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "字段映射关系", "min-width": "250" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.mark
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.getFullMarkFields(scope.row.mark),
                                      function (field) {
                                        return _c(
                                          "div",
                                          {
                                            key: field.key,
                                            staticStyle: {
                                              "line-height": "24px",
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  width: "80px",
                                                  color: "#606266",
                                                  "font-weight": "500",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(field.label) + "："
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.getMappingValue(
                                              scope.row.paramsMappingJson,
                                              field.key
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#1989fa",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n        " +
                                                        _vm._s(
                                                          _vm.getMappingValue(
                                                            scope.row
                                                              .paramsMappingJson,
                                                            field.key
                                                          )
                                                        ) +
                                                        "\n      "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [_vm._v("空")]
                                                ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#909399",
                                        "font-size": "12px",
                                      },
                                    },
                                    [_vm._v("未配置模板标识")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      12074864
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", width: "150", label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["admin:templatemessage:update"],
                                      expression:
                                        "['admin:templatemessage:update']",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addOrUpdateHandle(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("编辑\n          ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3217444853
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTenant && _vm.tenantId
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageIndex,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  layout: "total, prev, pager, next",
                },
                on: {
                  "size-change": _vm.sizeChangeHandle,
                  "current-change": _vm.currentChangeHandle,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.addOrUpdateVisible && _vm.selectedTenant && _vm.tenantId
        ? _c("add-or-update", {
            ref: "addOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }